import React, { useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import KitEditor from "src/components/TextEditorKit/KitEditor";
import { USE_TEXT_EDITOR_KIT } from "src/components/TextEditorKit/editorKitConfig";
import { invokeApi } from "src/bl_libs/invokeApi";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentSettingState";

function LegacyTinyEditor({
  setDetailDescription,
  detailDescriptionCk,
  height,
  // Optional (backwards compatible): receive the TinyMCE instance, and
  // extra init options merged over the defaults below.
  onInit,
  init: initOverrides,
}) {
  const editorRef = useRef(null);
  const { tinymceKey } = useContentSetting();
  const [focuse, setfocuse] = useState(false);
  const log = () => {
    if (editorRef.current) {
      setDetailDescription(editorRef.current.getContent());
    }
  };
  function example_image_upload_handler(blobInfo, success, failure, progress) {
    let requestObj = {
      path: "/app/update_image_on_s3/",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };

    let _formData = new FormData();
    _formData.append("image", blobInfo.blob());
    _formData.append("width", "600");
    requestObj["postData"] = _formData;

    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        success(s3baseUrl + res.image_path);
      } else {
        failure(res.message);
      }
    });
  }

  function handleEditorInit() {
    setTimeout(() => {
      let containerWarning = document.getElementsByClassName(
        "tox-notification--warning",
      );
      if (containerWarning.length > 0) {
        containerWarning[0].style.display = "none";
        setfocuse(false);
      }
      setfocuse(false);
    }, 100);
  }
  useEffect(() => {
    handleEditorInit();
  }, [focuse]);

  return (
    <>
      <Editor
        apiKey={tinymceKey}
        onChange={log}
        value={detailDescriptionCk}
        onInit={(evt, editor) => {
          editorRef.current = editor;
          handleEditorInit();
          if (onInit) onInit(editor);
        }}
        onEditorChange={(newValue, editor) => {
          setDetailDescription(editor.getContent());
          setfocuse(true);
        }}
        init={{
          setup: function (editor) {
            editor.on("focus", function (e) {
              setfocuse(true);
            });
          },
          images_upload_handler: example_image_upload_handler,
          height: height ? height : 400,
          z_index: 13000,
          menubar: true,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "emoticons",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          contextmenu: false,
          toolbar:
            "undo redo | bold italic forecolor backcolor | blocks | " +
            "alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          ...(initOverrides || {}),
        }}
      />
    </>
  );
}

/**
 * EDITOR-KIT: shows React Editor Kit instead of TinyMCE.
 * Same props as before (detailDescriptionCk, setDetailDescription, height).
 * onInit(editor) still works: it gets a small TinyMCE-like handle
 * (insertContent, focus, getContent, on("focus")).
 * kitVariant="email" gives the short email toolbar.
 * Set USE_TEXT_EDITOR_KIT = false in TextEditorKit/editorKitConfig.js to get
 * the old TinyMCE editor back.
 */
export default function TinyEditor(props) {
  const { detailDescriptionCk, setDetailDescription, height, onInit, kitVariant } = props;
  if (!USE_TEXT_EDITOR_KIT) return <LegacyTinyEditor {...props} />;
  return (
    <KitEditor
      value={detailDescriptionCk || ""}
      onChange={(html) => setDetailDescription(html)}
      height={height || 400}
      variant={kitVariant || "full"}
      onReady={onInit}
    />
  );
}
